export function randomId() {
  return Math.random().toString(36).slice(4);
}
